const shouldFilterNullValues = (device) => {
  // Apply null filtering to all devices instead of only specific Zewa models
  if (!device) return false;
  return true;
};

export default shouldFilterNullValues;
